// extracted by mini-css-extract-plugin
module.exports = {"component":"styles_component__ol2yg","rest":"styles_rest__YjE_t","smallLabel":"styles_smallLabel__MS8cv","doorman":"styles_doorman__jhvyn"};